import BaseService from './BaseService'
import axios from 'axios'

export default class ShipyardService extends BaseService {
  static async getCatalog () {
    const resp = await axios.get('/api/v1/protected/users/shipyard/catalog')

    return this.parseResponse(resp, false)
  }

  static async purchase (drawingId, name) {
    const resp = await axios.post('/api/v1/protected/users/shipyard/purchases', {
      purchase: {
        drawing_id: drawingId,
        name,
      },
    })

    return this.parseResponse(resp, false)
  }

  static async updatePrice (id, price) {
    const resp = await axios.patch(`/api/v1/protected/users/shipyard/prices/${id}`, {
      drawing_price: { price },
    })

    return this.parseResponse(resp, false)
  }
}
